import { call, put } from 'redux-saga/effects';
import history from './history';

export default function* responseHandler({ response, storeSaver, violations }) {
  if (response.status === 500) {
    yield call(history.push, '/500');
  }

  const data = yield response.json();
  if (data.violations) {
    yield put(violations.validationSetter(violations.validationTarget, data.violations));
  } else {
    yield put(storeSaver(data));
  }
}
